import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const footerLinks = {
    'Trademark Services': [
      { name: 'Trademark Search', url: '/services/trademark-search' },
      { name: 'Trademark Clearance', url: '/services/trademark-clearance' },
      { name: 'Trademark Application', url: '/services/trademark-application' },
      { name: 'Statement of Use', url: '/services/statement-of-use' },
      { name: 'Trademark Monitoring', url: '/services/trademark-monitoring' },
      { name: 'Office Actions', url: '/services/office-actions' },
      { name: 'Change of Ownership', url: '/services/change-of-ownership-transfer' },
      { name: 'Portfolio Management', url: '/services/portfolio-management' }
    ],
    'Copyright Services': [
      { name: 'Copyright Registration', url: '/services/copyright-registration' },
      { name: 'Copyright Enforcement', url: '/services/copyright-enforcement' },
      { name: 'Assignments & Licensing', url: '/services/copyright-assignments-licensing' },
      { name: 'Copyright Litigation', url: '/services/copyright-litigation' },
      { name: 'Copyright Portfolio', url: '/services/copyright-portfolio' },
      { name: 'DMCA Services', url: '/services/dmca' }
    ],
    'Patent & Formation': [
      { name: 'Patent Searches', url: '/services/patent-searches' },
      { name: 'Patent Applications', url: '/services/patent-applications' },
      { name: 'Patent Office Actions', url: '/services/patent-office-actions' },
      { name: 'Patent Enforcement', url: '/services/patent-enforcement' },
      { name: 'LLC Formation', url: '/services/llc-formation' },
      { name: 'C-Corp Formation', url: '/services/c-corp-formation' },
      { name: 'S-Corp Formation', url: '/services/s-corp-formation' },
      { name: 'Non-Profit Formation', url: '/services/nonprofit-formation' }
    ],
    'Company': [
      { name: 'About Us', url: '/about' },
      { name: 'Contact Us', url: '/contact' },
      { name: 'Blogs', url: '/resources/blogs' },
      { name: 'News & Updates', url: '/resources/news' },
      { name: 'Publications', url: '/resources/publications' },
      { name: 'Privacy Policy', url: '/privacy-policy' },
      { name: 'Terms & Conditions', url: '/terms-conditions' }
    ]
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Logo and Contact - Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-12 gap-6">
          {/* Logo - Left */}
          <div className="flex items-center">
            <img 
              src="/logo-light.png" 
              alt="Trademark Supremacy" 
              className="h-16 w-auto"
            />
          </div>

          {/* Contact Number - Right */}
          <div className="text-center md:text-right">
            <div className="text-sm text-gray-400 mb-1">Have Questions? Call Us</div>
            <a 
              href="tel:+14158543407" 
              className="text-2xl md:text-3xl font-bold text-white hover:text-[#FF6B35] transition-colors duration-300"
            >
              +1 (415) 854 3407
            </a>
            <div className="text-sm text-gray-400 mt-1">Available Mon-Fri, 9AM-6PM EST</div>
          </div>
        </div>

        {/* Footer Links */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="font-semibold text-lg mb-4">{category}</h3>
              <ul className="space-y-2">
                {links.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.url}
                      className="text-gray-400 hover:text-[#FF6B35] transition-colors text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Payment Icons */}
        <div className="flex flex-col items-center mb-8 pb-8 border-b border-gray-800">
          <p className="text-gray-400 text-sm mb-4">Secure Payment Methods</p>
          <div className="flex items-center gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_brandsecure-app/artifacts/5e7tqwc0_visa_inc_logo.svg.png" 
              alt="Visa" 
              className="h-8 object-contain bg-white rounded px-2 py-1"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_brandsecure-app/artifacts/s627i5nw_Mastercard.png" 
              alt="Mastercard" 
              className="h-8 object-contain bg-white rounded px-2 py-1"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_brandsecure-app/artifacts/dziyszf0_American%20Express.png" 
              alt="American Express" 
              className="h-8 object-contain bg-white rounded px-2 py-1"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_brandsecure-app/artifacts/cdbp1szs_Discover.png" 
              alt="Discover" 
              className="h-8 object-contain bg-white rounded px-2 py-1"
            />
          </div>
        </div>

        {/* Bottom Text */}
        <div className="text-center text-gray-400 text-sm">
          <p className="mb-2">
            © 2025 Trademark Supremacy Inc. All Rights Reserved.
          </p>
          <p className="text-xs">
            This website provides trademark registration services and is not affiliated with the USPTO.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;